<div class="position-absolute loader-close">
  <button type="button" class="btn-close pull-right" aria-label="Close" (click)="close()">
  </button>
</div>

<ng-container *ngIf="!valueTemplate">
  <div class="sk-wave" [class.colored]="!!backgroundColor">
    <div class="sk-rect sk-rect1" [style.background-color]='backgroundColor'></div>
    <div class="sk-rect sk-rect2" [style.background-color]='backgroundColor'></div>
    <div class="sk-rect sk-rect3" [style.background-color]='backgroundColor'></div>
    <div class="sk-rect sk-rect4" [style.background-color]='backgroundColor'></div>
    <div class="sk-rect sk-rect5" [style.background-color]='backgroundColor'></div>
  </div>
</ng-container>
<ng-container
  [ngTemplateOutlet]="valueTemplate">
</ng-container>

<ul style="position: fixed; bottom: 0; right: 10px;" class="list-unstyled">
  <ng-container *ngFor="let u of urls$ | async">
    <li class="text-end">{{u}}</li>
  </ng-container>
</ul>
